module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zer",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "left": "0"
    }
  }, [_c('div', {
    staticClass: "zer-main",
    staticStyle: {
      "background": "#fff",
      "width": "1020px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "zer-main"
    }
  }, [_c('a', {
    staticClass: "noprint Printing-btn",
    attrs: {
      "href": "javascript:window.print()"
    }
  }, [_vm._v("打印")]), _vm._v(" "), _c('div', {
    staticClass: "zerRep",
    attrs: {
      "id": "zerRep"
    }
  }, [_c('div', {
    staticClass: "report-zer "
  }, [_c('div', {
    staticClass: "emergency-btn fr",
    staticStyle: {
      "text-align": "center",
      "line-height": "30px",
      "margin": "22px 80px 0 0"
    }
  }, [_vm._v(_vm._s(_vm.patientRep.clinicType))]), _vm._v(" "), _c('div', {
    staticClass: "zer-report-head"
  }, [_c('div', {
    staticClass: "hos-name"
  }, [_vm._v(_vm._s(_vm.patientRep.hosName))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.patientRep.examTypeName) + "检查诊断报告单"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.patientRep.clinicType != undefined),
      expression: "patientRep.clinicType!=undefined"
    }]
  }, [_vm._v("（" + _vm._s(_vm.patientRep.clinicType) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "zer-report clearfix"
  }, [_c('div', {
    staticClass: "zer-report-l"
  }, [_c('ul', {
    staticClass: "infor infor-top"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("姓 名")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.patientName))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("姓 别")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.patientSex))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("年 龄")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.patientAge))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.patientRep.examTypeName) + " 号")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.accessionNumber))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("影 像 号")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.accessionNumber))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("科 室")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.requestDepartment))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("检查项目")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.examBodyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "infor infor-btm"
  }, [_c('ul', {
    staticClass: "rtd"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("审核医生")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.approveDoctor))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "adt"
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("报告书写")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.reportDoctor))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("检查时间")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.studiesDoneDts[0]) + " ")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.studiesDoneDts[1]))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("报告时间")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.approveDts[0]) + " ")]), _c('span', [_vm._v(_vm._s(_vm.patientRep.approveDts[1]))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "zer-report-r"
  }, [_c('div', {
    staticClass: "details-top clearfix"
  }, [_c('p', {
    staticClass: "details-n"
  }, [_vm._v("影像所见 :")]), _vm._v(" "), _c('div', {
    staticClass: "details-c"
  }, [_c('p', [_vm._v(_vm._s(_vm.patientRep.reportEvidences))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-btm clearfix"
  }, [_c('p', {
    staticClass: "details-n"
  }, [_vm._v("影像诊断 :")]), _vm._v(" "), _c('div', {
    staticClass: "details-c"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.patientRep.reportConclusion))])])])])])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atg"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zer-footer"
  }, [_c('ul', [_c('li', [_vm._v("*请凭此报告单到取片处取片")]), _vm._v(" "), _c('li', [_vm._v("*此单仅供本院医师参考，不做证明")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-51a4bb95","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/report/zerReport.vue
// module id = 566
// module chunks = 1 2 3 4 5 6 7 8